import script from "./OverviewIndex.vue?vue&type=script&setup=true&lang=ts"
export * from "./OverviewIndex.vue?vue&type=script&setup=true&lang=ts"

import "./OverviewIndex.vue?vue&type=style&index=0&id=2e87e748&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e87e748"]])

export default __exports__